var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_89_1410)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.759766,
    y: 0.930664,
    width: 30.4228,
    height: 30.4026,
    rx: 5,
    fill: "#1E1E1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6305 11.8264V20.8133C24.6305 21.3974 24.1233 21.8703 23.4969 21.8703H20.8505V15.8795L16.3153 19.052L11.78 15.8795V21.871H9.13365C8.98472 21.871 8.83724 21.8436 8.69966 21.7904C8.56207 21.7373 8.43707 21.6594 8.33179 21.5611C8.22651 21.4629 8.14303 21.3463 8.08609 21.218C8.02916 21.0897 7.99991 20.9521 8 20.8133V11.8264C8 10.5194 9.59999 9.77309 10.7212 10.5575L11.78 11.2986L16.3153 14.4697L20.8505 11.2973L21.9093 10.5575C23.0298 9.77374 24.6305 10.5194 24.6305 11.8264Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_89_1410",
    x: -39.2402,
    y: -39.0693,
    width: 110.423,
    height: 110.403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_89_1410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_89_1410",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/Gmail Icon.a61432d0d7a33733b0b392aadf5a0356.svg";
export { ForwardRef as ReactComponent };